import { useShipmentsOverviewContext } from '@/modules/pmt/context';
import type { FC } from 'react';
import { ShipmentListSectionWrapper, ShipmentsOverviewWrapper } from './ShipmentsOverview.styles';
import { NoShipmentsLayout } from './components/NoShipmentsLayout';
import { ShipmentListLayout } from './components/ShipmentListLayout';
import { ShipmentSearch } from './components/ShipmentSearch';

export const ShipmentsOverview: FC = () => {
  const { noShipmentsAdded } = useShipmentsOverviewContext();

  return (
    <ShipmentsOverviewWrapper noShipmentsAdded={noShipmentsAdded}>
      <ShipmentListSectionWrapper>
        <ShipmentSearch />
        {noShipmentsAdded ? <NoShipmentsLayout /> : <ShipmentListLayout />}
      </ShipmentListSectionWrapper>
    </ShipmentsOverviewWrapper>
  );
};
